<div [formGroup]="formGroup" class="form-group" [class.has-error]="!isValid(formGroup, ctrl)" [libCtrConfigUI]="ctrl"
  [altura]="ctrl?.Altura" [isMobile]="isMobile" [tabIndex]="getTabIndex(ctrl)">

  <lib-title-label [id]="getId(ctrl)" [formGroup]="formGroup" [isMobile]="isMobile" [enTheme]="enTheme" [ctrl]="ctrl"
    #lblTitle></lib-title-label>
  ctr-video works!

</div>